import * as suspensionService from "@hub/management/src/modules/suspensions/services/suspension.service"

export default {
  async fetchSuspensionTypes({ commit }) {
    try {
      const { data } = await suspensionService.fetchSuspensionTypes()
      commit("setSuspensionTypes", data)
    } catch (error) {
      console.error("Erro ao buscar tipos de suspensão:", error)
    }
  }
}
